// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum ClientEndpointMS2ScheduleMode {
	Direct = 0,
	Interval = 1,
	Daily = 2,
}

export const ClientEndpointMS2ScheduleModeDisplayNames: { [key in keyof typeof ClientEndpointMS2ScheduleMode]?: string} = {
	"Direct": "Device sends directly",
	0 : "Device sends directly",
	"Interval": "OmniSight sends every few minutes",
	1 : "OmniSight sends every few minutes",
	"Daily": "OmniSight sends once a day",
	2 : "OmniSight sends once a day",
}

export const getClientEndpointMS2ScheduleModeDisplayName = (key: ClientEndpointMS2ScheduleMode | (keyof typeof ClientEndpointMS2ScheduleMode & string)) => {
	return ClientEndpointMS2ScheduleModeDisplayNames[key];
}

